import React from 'react';
import { bool, node, shape, string } from 'prop-types';
import clsx from 'clsx';

import FormLabel from '@material-ui/core/FormLabel';

import defaultClasses from './TagSelectLabel.module.css';

const TagSelectLabel = ({ children, classes, disabled, error, ...props }) => (
    <FormLabel
        {...props}
        classes={{
            ...classes,
            root: clsx(
                defaultClasses.root,
                classes.root,
                {
                    [defaultClasses.disabled]: disabled,
                    [defaultClasses.error]:    error
                }
            )
        }}
    >
        {children}
    </FormLabel>
);

TagSelectLabel.defaultProps = {
    classes:  {},
    disabled: false,
    error:    false
};

TagSelectLabel.propTypes = {
    children: node,
    classes:  shape({
        root: string
    }),
    disabled: bool,
    error:    bool
};

export default TagSelectLabel;
